import React, { useContext, useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';

import { qualityApi as api } from 'api/quality';
import { UserContext } from 'contexts/UserContext';
import { DataTable, Notifications } from 'shared';

function ViewCCOF() {
    const [notification, setNotification] = useState({ text: '', level: '' });
    const [rows, setRows] = useState([]);
    const user = useContext(UserContext);

    const getRows = async () => {
        const res = await api.getCCOF(user.getFacilityID());
        if (res.status) {
            setRows(res.data.rows);
        }
    };

    useEffect(() => {
        getRows();
    }, []);

    const columns = [
        { accessor: 'id', Header: 'Shipment ID' },
        { accessor: 'shopOrderNum', Header: 'Order Number' },
    ];

    return (
        <Grid container>
            <Notifications options={notification} />
            <Grid item md={12} style={{ textAlign: 'left', paddingLeft: '40px' }}>
                <h1>Shipments to use for a CCOF Audit</h1>
            </Grid>
            <Grid item xs={12}>
                <DataTable data={rows} columns={columns} />
            </Grid>
        </Grid>
    );
}

export { ViewCCOF };
